/** Valeurs par défaut (déployées). Surchargeables via l’URL pour les tests. */
const FLAG_DEFAULTS = {
  ENABLE_PHOTOBOOTH: false,
  ENABLE_QUEST: false,
} as const;

export type FeatureFlags = { [K in keyof typeof FLAG_DEFAULTS]: boolean };

type FeatureFlagKey = keyof typeof FLAG_DEFAULTS;

function readUrlOverrides(search: string): Partial<Record<FeatureFlagKey, boolean>> {
  const query = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(query);
  const overrides: Partial<Record<FeatureFlagKey, boolean>> = {};

  for (const flagKey of Object.keys(FLAG_DEFAULTS) as FeatureFlagKey[]) {
    const value = params.get(flagKey);
    if (value === null) continue;
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true') overrides[flagKey] = true;
    else if (normalized === 'false') overrides[flagKey] = false;
  }

  return overrides;
}

/** Fusionne les défauts avec les surcharges de l’URL (?ENABLE_PHOTOBOOTH=true, ?ENABLE_QUEST=true, etc.). */
export function getFeatureFlags(search = ''): FeatureFlags {
  const overrides = readUrlOverrides(search);
  return { ...FLAG_DEFAULTS, ...overrides };
}
